import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const fetchOrderPackages = createAction(ACTION.FETCH_ORDER_PACKAGES.REQUEST, orderId => ({orderId}));
export const clearState = createAction(ACTION.CLEAR_STATE, packageCode => ({packageCode}));
